var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionpage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 630,
    height: 790,
    viewBox: "0 0 630 790",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solutionpage",
    transform: "translate(-286 -27703)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 630,
    height: 790,
    rx: 26,
    transform: "translate(286 27703)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 308,
    height: 162,
    rx: 31,
    transform: "translate(447 28079)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title",
    width: 161,
    height: 13,
    rx: 6.5,
    transform: "translate(383 27848)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-2",
    "data-name": "Title",
    width: 161,
    height: 13,
    rx: 6.5,
    transform: "translate(447 28273)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-3",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(616 27848)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-4",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(447 28311)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-5",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(616 27872)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-6",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(447 28335)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-7",
    "data-name": "Title",
    width: 139,
    height: 13,
    rx: 6.5,
    transform: "translate(447 28359)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-8",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(616 27897)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-9",
    "data-name": "Title",
    width: 126,
    height: 13,
    rx: 6.5,
    transform: "translate(616 27921)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7016",
    "data-name": "Group 7016",
    transform: "translate(-721 984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_3",
    "data-name": 3,
    width: 24,
    height: 11,
    rx: 5.5,
    transform: "translate(1565 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2",
    "data-name": 2,
    width: 24,
    height: 11,
    rx: 5.5,
    transform: "translate(1530 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_1",
    "data-name": 1,
    width: 23,
    height: 11,
    rx: 5.5,
    transform: "translate(1495 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 56,
    height: 18,
    rx: 9,
    transform: "translate(1055 26746)",
    fill: "#858585"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Title-10",
    "data-name": "Title",
    width: 61,
    height: 10,
    rx: 5,
    transform: "translate(339 28028)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-11",
    "data-name": "Title",
    width: 38,
    height: 10,
    rx: 5,
    transform: "translate(339 27791)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-12",
    "data-name": "Title",
    width: 51,
    height: 10,
    rx: 5,
    transform: "translate(389 27791)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-13",
    "data-name": "Title",
    width: 12,
    height: 41,
    rx: 6,
    transform: "translate(862 27997)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-14",
    "data-name": "Title",
    width: 62,
    height: 24,
    rx: 12,
    transform: "translate(447 28397)",
    fill: "#858585"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionpage);
export default __webpack_public_path__ + "static/media/solutionpage.c7bcbd4eb532e818bd03bfea7cfc428c.svg";
export { ForwardRef as ReactComponent };